// AB module: shell/dashboard/monitoring/inbox ("UI parity" wave, Agent FE-1). Key-for-key
// English counterpart of abShell.de.js.
const abShell = {
  // ---- Sidebar navigation ----
  'ab.shell.navDashboard': 'Dashboard',
  'ab.shell.navDocuments': 'Documents',
  'ab.shell.navMonitoring': 'Monitoring',

  // ---- Sync (header) ----
  'ab.shell.syncButton': 'Sync',
  'ab.shell.syncBusy': 'Syncing…',
  'ab.shell.syncNoRunYet': 'No sync yet',
  'ab.shell.syncLastRun': 'Last sync {when}',
  'ab.shell.syncNewCount': '{n} new',
  'ab.shell.syncFailed': 'failed',
  'ab.shell.syncDisabledInfo': 'Mail inbox is not configured.',
  'ab.shell.timeJustNow': 'just now',
  'ab.shell.timeMinAgo': '{n} min ago',
  'ab.shell.timeHoursAgo': '{n} h ago',
  'ab.shell.timeDaysAgo': '{n} d ago',

  // ---- Reports flag (own reports) ----
  'ab.shell.myReportsTitle': 'My reports',
  'ab.shell.myReportsAriaLabel': 'My reports ({n} open)',
  'ab.shell.myReportsSubtitle': 'Documents you reported for review',
  'ab.shell.myReportsTabAll': 'All',
  'ab.shell.myReportsTabOpen': 'Open',
  'ab.shell.myReportsTabDone': 'Done',
  'ab.shell.myReportsOpen': 'Open',
  'ab.shell.myReportsDone': 'Done',
  'ab.shell.myReportsEmpty': 'You haven\'t reported any documents yet. You can report a document from its detail view via the "Report" button.',
  'ab.shell.myReportsLoadError': 'Reports could not be loaded',
  'ab.shell.myReportsReportedOn': 'Reported on {date}',
  'ab.shell.myReportsHistory': 'History',
  'ab.shell.myReportsNoComments': 'No comments.',
  'ab.shell.commentKind.report': 'reported',
  'ab.shell.commentKind.resolve': 'resolved',
  'ab.shell.commentKind.comment': 'comment',

  // ---- Notification bell (AI rule-set suggestion jobs) ----
  'ab.shell.notifTitle': 'Notifications',
  'ab.shell.notifEmpty': 'No new notifications.',
  'ab.shell.notifAckAll': 'Acknowledge all',
  'ab.shell.notifAck': 'Acknowledge',
  'ab.shell.notifRunning': 'AI is creating a rule-set suggestion for document #{id} … running in the background',
  'ab.shell.notifDone': 'AI suggestion ready for document #{id}',
  'ab.shell.notifDoneOpen': 'Open document',
  'ab.shell.notifError': 'AI suggestion for document #{id} failed',

  // ---- Dashboard ----
  'ab.shell.dashTitle': 'Dashboard',
  'ab.shell.dashSubtitle': 'Inbox & processing status at a glance',
  'ab.shell.dashLoadError': 'Dashboard could not be loaded',
  'ab.shell.heroOpen': '{n} open items',
  'ab.shell.heroClear': 'All clear',
  'ab.shell.kpiInbox': 'Inbox',
  'ab.shell.kpiNoRuleset': 'No rule set',
  'ab.shell.kpiNeedsReview': 'Needs approval',
  'ab.shell.kpiFailed': 'Errors',
  'ab.shell.kpiTransferredToday': 'Transferred today',

  // ---- Inbox panel (dashboard) ----
  'ab.shell.inboxTitle': 'Inbox',
  'ab.shell.inboxSearchPlaceholder': 'Search inbox…',
  'ab.shell.inboxLoadError': 'Inbox could not be loaded',
  'ab.shell.inboxEmptyOpen': 'All done — no open emails.',
  'ab.shell.inboxEmptyDone': 'No completed emails yet.',
  'ab.shell.inboxEmptySearch': 'No matches for "{q}".',
  'ab.shell.inboxNotConfigured': 'Mail inbox is not configured.',
  'ab.shell.inboxNotConfiguredHint': 'Automatic mail retrieval is disabled on this system — documents can still be uploaded manually.',
  'ab.shell.mailNoSubject': '(no subject)',
  'ab.shell.mailStatus.claimed': 'Processing',
  'ab.shell.mailStatus.processed': 'Processed',
  'ab.shell.mailStatus.failed': 'Failed',
  'ab.shell.mailStatus.ignored': 'Ignored',

  // ---- 7-day trend / top suppliers / today's figures ----
  'ab.shell.trendTitle': '7-day trend',
  'ab.shell.trendReceived': 'received',
  'ab.shell.trendTransferred': 'transferred',
  'ab.shell.trendEmpty': 'No data yet.',
  'ab.shell.suppliersTitle': 'Top suppliers',
  'ab.shell.suppliersSubtitle': 'last 7 days',
  'ab.shell.suppliersEmpty': 'No documents in the last 7 days.',
  'ab.shell.todayTitle': 'Today\'s figures',
  'ab.shell.todayReceived': 'Received',
  'ab.shell.todayExtracted': 'Extracted',
  'ab.shell.todayApproved': 'Approved',
  'ab.shell.todayRejected': 'Rejected',
  'ab.shell.todayEmpty': 'No processing yet today.',

  // ---- Documents page + filters ----
  'ab.shell.documentsTitle': 'Documents',
  'ab.shell.documentsSubtitle': 'All captured order confirmations',
  'ab.shell.filterStatusAll': 'All',
  'ab.shell.filterSupplier': 'Supplier',
  'ab.shell.filterSupplierAll': 'All suppliers',
  'ab.shell.filterSupplierNone': 'No supplier',
  'ab.shell.filterFrom': 'From',
  'ab.shell.filterTo': 'To',
  'ab.shell.filterCommitted': 'Transferred',
  'ab.shell.filterCommittedAll': 'All',
  'ab.shell.filterCommittedYes': 'Transferred',
  'ab.shell.filterCommittedNo': 'Not transferred',
  'ab.shell.filterReset': 'Reset filters',
  'ab.shell.reportedTooltip': 'This document was reported for review',

  // ---- Monitoring ----
  'ab.shell.monitoringTitle': 'Monitoring',
  'ab.shell.monitoringSubtitle': 'Processing logs of the order confirmation capture',
  'ab.shell.monNoAccess': 'No access — this page is for administrators only.',
  'ab.shell.monTabMail': 'Mail',
  'ab.shell.monTabExtraction': 'Extraction',
  'ab.shell.monTabLlm': 'AI',
  'ab.shell.monTabActions': 'Actions',
  'ab.shell.monTabReported': 'Reported',
  'ab.shell.monEmpty': 'No entries found.',
  'ab.shell.monLoadError': 'Data could not be loaded',
  'ab.shell.monOpen': 'open',
  'ab.shell.monColReceived': 'Received',
  'ab.shell.monColStatus': 'Status',
  'ab.shell.monColSender': 'Sender',
  'ab.shell.monColSubject': 'Subject',
  'ab.shell.monColReasonError': 'Reason / error',
  'ab.shell.monColDocument': 'Document',
  'ab.shell.monColTime': 'Time',
  'ab.shell.monColEvent': 'Event',
  'ab.shell.monColActor': 'User',
  'ab.shell.monColDetail': 'Detail',
  'ab.shell.monColStarted': 'Started',
  'ab.shell.monColModel': 'Model',
  'ab.shell.monColReported': 'Reported',
  'ab.shell.monColReportedBy': 'Reported by',
  'ab.shell.monColReportStatus': 'Report status',
  'ab.shell.monResolve': 'Resolve',
  'ab.shell.monResolveDialogTitle': 'Resolve report?',
  'ab.shell.monResolveCommentPlaceholder': 'Comment on the resolution…',
  'ab.shell.monResolveCommentRequired': 'Please enter a comment',
  'ab.shell.monResolvedMsg': 'Report resolved',
  'ab.shell.event.reported': 'Reported',
  'ab.shell.event.report_resolved': 'Report resolved',

  // ---- Email detail view ----
  'ab.shell.mailDetailTitle': 'Email',
  'ab.shell.mailDetailSender': 'Sender',
  'ab.shell.mailDetailReceived': 'Received',
  'ab.shell.mailDetailStatus': 'Status',
  'ab.shell.mailDetailBody': 'Email text',
  'ab.shell.mailDetailBodyEmpty': 'No email text stored.',
  'ab.shell.mailDetailDocuments': 'Linked documents',
  'ab.shell.mailDetailLoadError': 'Email could not be loaded',

  // ---- Generic (pager for new lists) ----
  'ab.shell.pageInfo': 'Page {page} of {totalPages} · {total} results',
};

export default abShell;
